module.exports = __webpack_public_path__ + "d4d493d53bf5f63260a00078b46d2341.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/pt.json
// module id = 1133
// module chunks = 0